import React, {useEffect, useState, useRef} from 'react'
import { Link, useAsyncError } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MemberCard from '../../components/MemberCard/memberCard';
import Footer from '../../components/Footer';
import { getMonthlyJoined, threeDayExpire, fourToSevenDaysExpire, expired, inActiveMembers  } from "./data";

const GeneralUser = () => {

    const [header, setHeader] = useState("");
    const [data, setData]= useState([]);


useEffect(()=>{
    const func = sessionStorage.getItem('func');
    functionCall(func);
}, [])

const functionCall = async(func)=>{
    switch(func){

case "monthlyjoined":
    setHeader("Monthly Joined Members")
    var datas = await getMonthlyJoined();
    setData(datas.members);
break;

case "threeDayExpire":
    setHeader("Expiring In 3 Days Members")
    var datas = await threeDayExpire();
    setData(datas.members);
break;

case "fourToSevenDaysExpire":
    setHeader("Expiring In 4-7 Days Members")
     var datas = await fourToSevenDaysExpire();
    setData(datas.members);
break;

case "expired":
    setHeader("Expired Members")
    var datas = await expired();
    setData(datas.members);
break;

case "inActiveMembers":
    setHeader("Monthly Joined Members")
    var datas = await inActiveMembers();
    setData(datas.members);
break;


    }
}

  return (
    <div>
    <div className='dashboard-box generaluser'>
      <div  className='generaluser1'>
      <div>
      <Link to={'/dashboard'} className='dashbacklink'>
       <ArrowBackIcon /> Back to Dashboard
      </Link>
      </div>

      <div>
        {header}
      </div>
      </div>

      <div className='projects__container container grid membercars dashboard-box-1'>
      {
        data.map((item, index)=>{
            return(
                   <MemberCard item={item} />
            );
        })
      }
      </div>
  
    </div>
     <Footer />
    </div>
    

  )
}

export default GeneralUser
